module.exports = __webpack_public_path__ + "img/brand-hino.cd81e626.png";